module.exports = __webpack_public_path__ + "img/val-employee-hover.a98c5da4.png";